<template>
  <div class="from">
      <div class="input">
        <form action>
          <h4>線上聯絡表單：</h4>
          <div class="group">
            <input type="text" placeholder="姓名*" v-model="message.name" />
          </div>
          <div class="group">
            <input type="text" placeholder="E-mail" v-model="message.email"/>
          </div>
          <div class="group">
            <input type="text" placeholder="連絡電話*" v-model="message.phone"/>
          </div>
          <div class="group">
            <textarea type="text" placeholder="留言訊息" v-model="message.message"></textarea>
          </div>
          <Button :msg="button"
          :btncolor="btncolor"
          @clickbutton="sendMessage"></Button>
        </form>
      </div>
    </div>
</template>

<script>
import Button from '@/components/only_button.vue';

export default {
  props: {
    btncolor: {
      type: Array,
      default: () => (['only_form', 'hover-btn']),
    },
  },
  data() {
    return {
      button: '發送訊息',
      message: {
        name: '',
        email: '',
        phone: '',
        message: '',
      },
    };
  },
  components: {
    Button,
  },
  methods: {
    sendMessage() {
      const api = 'https://brycehuang.com/api/contact/';
      console.log(this.message);
      const formdata = new FormData();
      formdata.append('name', this.message.name);
      formdata.append('email', this.message.email);
      formdata.append('phone', this.message.phone);
      formdata.append('message', this.message.message);
      this.axios.post(api, formdata).then((response) => {
        console.log(response.data);
        if (response.data.result === 'successful') {
          // eslint-disable-next-line no-alert
          window.alert('傳送成功，請靜待回覆~');
          this.message = {
            name: '',
            email: '',
            phone: '',
            message: '',
          };
        } else {
          // eslint-disable-next-line no-alert
          window.alert('您好，姓名和電話一定要填寫喔~');
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.from {
  .input {
    h3 {
      margin-bottom: 20px;
    }
    .group {
      width: 100%;
      text-align: left;
      textarea,
      input {
        width: 100%;
        padding: 10px;
        margin-bottom: 10px;
        outline: none;
        border: none;
        border-radius: 10px;
        border: 1px solid #ddd;
      }
      textarea {
      min-height: 100px;
  }
    }
  }
}
</style>
